import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=3a01f22d&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=3a01f22d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a01f22d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a01f22d')) {
      api.createRecord('3a01f22d', component.options)
    } else {
      api.reload('3a01f22d', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=3a01f22d&scoped=true&", function () {
      api.rerender('3a01f22d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WN7Nc6LG93E8/JS/comp/CookieBox.vue"
export default component.exports